<template lang="pug">

.app-card.overflow-x-auto.hoods-styled-panel
  .d-flex(class='justify-end tw-mb-3')
    edit-hood-modal(
      :data-icon='"fa-solid fa-plus"'
      :data-label="$I18n.t('vue.hoods_detail_table_panel.title')"
      :data-mode='"new"'
      :data-item='JSON.stringify(empty_item)'
      :data-equipment-under-kinds='dataEquipmentUnderKinds'
      @updated='createNewHood'
    )

  //- Contador de hoods
  .tw-flex.tw-items-center.tw-gap-2.tw-mb-3.tw-text-sm.tw-text-gray-600(v-if='!emptyItems')
    i.fa-solid.fa-wind.tw-text-blue-500
    span 
      strong {{items.length}}
      |  hood(s) registered

  table(v-if='!emptyItems' class="table hoods-styled-table")
    thead
      tr.tw-text-xs
        th.tw-text-gray-500.tw-w-12 #
        th.tw-bg-blue-50
          i.fa-solid.fa-fire-burner.tw-mr-1.tw-text-orange-400
          | Equipment Under
        th.tw-bg-gray-50
          i.fa-solid.fa-align-left.tw-mr-1.tw-text-gray-400
          | Description
        th.tw-text-center.tw-w-24 Actions
    tbody
      tr(v-for="(item, index) in items" :key="item.id" class="hover:tw-bg-blue-50")
        //- Número
        td.tw-text-gray-400.tw-text-xs.tw-text-center {{index + 1}}
        //- Equipment Under
        td.tw-bg-blue-50.tw-bg-opacity-30
          .tw-flex.tw-items-center
            .tw-w-8.tw-h-8.tw-rounded.tw-bg-orange-100.tw-flex.tw-items-center.tw-justify-center.tw-mr-2
              i.fa-solid.fa-fire-burner.tw-text-orange-500.tw-text-sm
            span.tw-font-medium {{item.equipment_under || '-'}}
        //- Description
        td
          span.tw-text-gray-700(v-if="item.description") {{item.description}}
          span.tw-text-gray-300.tw-italic.tw-text-sm(v-else) No description
        //- Actions
        td.tw-text-center
          .tw-flex.tw-gap-1.tw-justify-center
            edit-hood-modal(
              :data-icon='"fa-solid fa-pencil"'
              :data-label='""'
              :data-mode='"edit"'
              :data-item='JSON.stringify(item)'
              :data-equipment-under-kinds='dataEquipmentUnderKinds'
              @updated='updateHood'
            )
            delete-hood-modal(
              :data-id='item.id'
              @deleted='deleteHood'
            )

  div
    .tw-text-center.tw-py-8.tw-text-gray-500(v-if='emptyItems')
      i.fa-solid.fa-wind.tw-text-3xl.tw-text-gray-300.tw-mb-2
      p.tw-mt-2 {{$I18n.t('vue.hoods_detail_table_panel.empty_items')}}

</template>
<script>

import DeleteHoodModal from './delete-hood-modal.vue'
import EditHoodModal from './edit-hood-modal.vue'
import {BackendService} from '../../services';
import CoreComponents from '../core';
import StickyTableMixin from '../../mixins/sticky_table_mixin.js';

export default {
  components:{
    'delete-hood-modal':DeleteHoodModal,
    'edit-hood-modal':EditHoodModal,
    "app-icon-btn": CoreComponents.AppIconBtn,
  },
  mixins: [StickyTableMixin],
  props:{
    dataId: String,
    dataModel: String,
    dataItems: String,
    dataEquipmentUnderKinds: String
  },
  data: function(){
    return {
      state: {
        confirmed: false,
      },
      empty_item:{
        equipment_under:"",
        description:"",
      },
      record:{
        id: this.dataId,
      },
      items: JSON.parse(this.dataItems),
      equipment_under_kinds_options: JSON.parse(this.dataEquipmentUnderKinds),
    }
  },
  computed:{
    emptyItems: function(){
      return this.items.length === 0;
    }
  },
  methods:{
    retrieveHoods:function(){
      location.reload();
    },
    createNewHood:function(item){
      const self = this;
      this.state.sending = true;
      let params = JSON.stringify({
        id: this.dataId,
        hood: JSON.parse(item)
      })
      BackendService
        .create_subsidary_hood(params)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    deleteHood:function(hood_id){
      const self = this;
      this.state.sending = true;
      BackendService
        .hood_delete(hood_id)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    updateHood:function(params){
      const self = this;
      this.state.sending = true;
      BackendService
        .hood_update(params)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
  }
}
</script>

<style scoped>
.hoods-styled-panel {
  padding: 1rem;
}

.hoods-styled-table {
  font-size: 0.85rem;
}

.hoods-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
}

.hoods-styled-table tbody td {
  vertical-align: middle;
  padding: 0.5rem 0.6rem;
}

.tw-bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
</style>
